import { Logo } from '@kanda-libs/ks-design-library';

const MainLayoutHeaderLogoHeader: React.FunctionComponent = function () {
  return (
    <>
      <Logo className="my-auto hidden md:block" />
      <Logo className="my-auto block md:hidden" compact />
    </>
  );
};

export default MainLayoutHeaderLogoHeader;
